import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Typography,
  usePagination,
  Link
} from "@mui/material";
import PortfolioCard from "../../../components/workloadAndPerformance/WorkloadAndPerformanceCard";
import DefaultForm from "../../../components/workloadAndPerformance/DefaultForm";
import CustomForm from "../../../components/workloadAndPerformance/CustomForm";
import AlertDialog from "../../../components/AlertDialog";
import SimpleDialog from "../../../components/SimpleDialog";
import ConfirmDialog from "../../../components/ConfirmDialog";
import { ReactComponent as PlusIcon } from "../../../icons/plus.svg";
import workloadAndPerformanceService from "../../../services/workloadAndPerformance.service";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
// import Request from "../../components/home/Request";
// import { getMyRequestSuccess } from "../../actions";
import { useSelector, useDispatch } from "react-redux";
import { getPortfolioList, getPortfolioDetail, getPortfolioDetailList, getPortfolioWorkloadTypeList, getPortfolioDetailSummary } from "../../../actions/portfolio";
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import React, { useEffect, useMemo } from "react";
import CloseIcon from "../../../assets/images/plus-circle-fill.svg";
import fileBrowser from "../../../icons/file-browser.svg";
import { styled } from "@mui/material/styles";
import cssVariables from "../../../theme/cssVariables";
import { useParams } from "react-router-dom";
import MessageDialog from "../../../components/inbox/MessageDialog";
import { ReactComponent as Arrow } from "../../../assets/images/arrow-right.svg";
import emtyData from "../../../assets/images/emty-data.png";
import * as Util from "../../../services/global.service";

// import axios from "axios";
function CustomPagination(props) {
  const useStyles = makeStyles({
    paginationRoot: {
      color: `${cssVariables.color.primary}`,
      backgroundColor: "white!important",
      minWidth: "30px!important",
      padding: "5px!important",
    },
    paginationSelected: {
      color: "white!important",
      border: "1px solid rgba(93, 161, 150, 0.5)!important",
      backgroundColor: `${cssVariables.color.primary}!important`,
      minWidth: "30px!important",
      padding: "5px!important",
    },

  });
  const classes = useStyles();
  const List = styled("ul")({
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
  });
  const { items } = usePagination({
    count: props.count,
    showFirstButton: true,
    showLastButton: true,
  });
  return (
    <nav>
      <List>
        {items.length > 0 ? (
          items.map(({ page, type, selected, ...item }, index) => {
            let children = null;
            selected = type === "page" && page === props.selected ? props.selected : selected
            if (type === "start-ellipsis" || type === "end-ellipsis") {
              children = "…";
            } else if (type === "page") {
              children = (
                <Button
                  {...item}
                  size="small"
                  type="button"
                  style={{
                    fontWeight: selected ? "bold" : undefined,
                  }}
                  variant="outlined"
                  classes={{
                    root: selected
                      ? classes.paginationSelected
                      : classes.paginationRoot,
                  }}
                  sx={{ margin: "0 5px" }}
                >
                  {page}
                </Button>
              );
            } else if (type === "first" || type === "last") {
              children = (
                <Button
                  {...item}
                  disabled={type === "first" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                  size="small"
                  type="button"
                  style={{
                    fontWeight: selected ? "bold" : undefined,
                  }}
                  variant="outlined"
                  classes={{
                    root: selected
                      ? classes.paginationSelected
                      : classes.paginationRoot,
                  }}
                  sx={{ margin: "0 5px" }}
                >
                  {type === "first" ? <>&lt;&lt;</> : <>&gt;&gt;</>}
                </Button>
              );
            } else {
              children = (
                <Button
                  {...item}
                  disabled={type === "previous" ? props.selected === 1 ? true : false : props.selected === props.count ? true : false}
                  size="small"
                  type="button"
                  variant="outlined"
                  classes={{
                    root: classes.paginationRoot,
                  }}
                >
                  {type === "previous"
                    ? "ก่อนหน้า"
                    : type === "next"
                      ? "ถัดไป"
                      : ""}
                </Button>
              );
            }
            return <li key={index}>{children}</li>;
          })

        ) : (
          <></>
        )}
        {props.setCurrentPage(items)}
      </List>
    </nav>
  );
}
const Portfolio = (props) => {
  const { t, i18n } = useTranslation();
  const portfolio = useSelector((state) => state.Portfolio);
  const dispatch = useDispatch();
  const [createFormData, setCreateFormData] = React.useState({
    "rb_work_category": "",
    "rb_work_condition": "",
    "description": "",
    "name": "",
    "remark": "",
  });

  // workload form select
  const [workloadFormSelect, setWorkloadForm] = React.useState([]);
  const [workloadFormSelectValue, setWorkloadFormValue] = React.useState("");
  const handleChangeWorkloadForm = (event) => {
    setWorkloadFormValue(event.target.value);
  };
  const [summaryItems, setSummaryItem] = React.useState({ total: 0, performance: 0, work: 0, progress: 0 });
  const handleChangeSummaryItem = (val) => {
    if (val) setSummaryItem(val);
  };
  const [workloadDetailList, setWorkloadDetailList] = React.useState([]);
  const [setWorkloadLimit, setWorkloadLimitValue] = React.useState(25);
  const handleChangeWorkloadDetailList = (val) => {
    if (val) setWorkloadDetailList(val);
  };
  const [selectedWorkloadType, setWorkloadTypeSelected] = React.useState("all");
  const [workloadTypeList, setWorkloadTypeList] = React.useState([
    // { "text": "งานสอน", "value": "งานสอน" },
    // { "text": "งานฝึกอบรม", "value": "งานฝึกอบรม" },
    // { "text": "ผลงานทางวิชาการ", "value": "ผลงานทางวิชาการ" },
    // { "text": "งานบริการวิชาการ", "value": "งานบริการวิชาการ" }
  ]);

  const handleChangeSelect = (_, val) => {
    if (val.props.value) setWorkloadLimitValue(val.props.value);
  };
  const titleAdd = () => {
    let data = ""
    if (workloadFormSelectValue !== "" && workloadFormSelectValue !== undefined && workloadFormSelectValue !== null && workloadFormSelect.length > 0) {
      let res = workloadFormSelect.find((res) => res.value === workloadFormSelectValue)
      if (res !== undefined && res !== null && res !== "") {
        if (res.name !== undefined && res.name !== null && res.name !== "") {
          data = res.name
        }
      }
    }
    return data
  }
  // on click
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const _ = require("lodash");
  const [filteredList, setFilteredList] = React.useState([]);
  const [groupedReq, setGroupReq] = React.useState([]);
  const [perPage, setPerPage] = React.useState(25);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPage, setTotalPage] = React.useState(1);
  const handleChangeWorkloadType = (_, val) => {
    if (val) setWorkloadTypeSelected(val);
    setCurrentPage(1);
    setValueTab(val);
  };
  const handlePerPageChange = (event) => {
    setPerPage(event.target.value);
  };
  const handleSetCurrentPage = (value) => {
    const getSelectedPage = value.filter(item => item.type === "page" && item.selected)
    setCurrentPage(getSelectedPage.length > 0 ? getSelectedPage[0].page : 1)
  };
  const handleTotalPage = () => {
    const List = filteredList?.filter(item => selectedWorkloadType !== "all" ? item.workTypeCode == selectedWorkloadType : item);
    const totalPage =
      Math.ceil(List.length / perPage) === 0
        ? 1
        : Math.ceil(List.length / perPage);
    setTotalPage(totalPage);
  };
  // update qty for each status when list changed
  useEffect(() => {
    setGroupReq(_.groupBy(workloadDetailList[props.selectedInbox], (loRow) => loRow.status));
    handleTotalPage();
  }, [filteredList]);
  const [valueTab, setValueTab] = React.useState("all");

  useEffect(() => {
    handleTotalPage();
  }, [valueTab]);
  const currentTableData = useMemo(() => {
    handleTotalPage();
    const firstPageIndex = (currentPage - 1) * perPage;
    const lastPageIndex = firstPageIndex + perPage;
    return filteredList
      ?.filter(item => selectedWorkloadType !== "all" ? item.workTypeCode == selectedWorkloadType : item)
      .slice(firstPageIndex, lastPageIndex);
  }, [filteredList, currentPage, props.selectedInbox, valueTab, perPage]);

  // dialog
  const [newForm, setForm] = React.useState(0);
  const [isAddDialogOpen, openDialog] = React.useState(false);
  const handleOpenDialog = (event) => {
    openDialog(true)
    setForm(1)
    handleClose()
  };
  const handleCloseDialog = () => {
    openDialog(false);
    setEditForm({ id: "", isManual: "" })
    setCreateFormData({
      ...createFormData, ...{
        rb_work_category: "",
        rb_work_condition: "",
        description: "",
        name: "",
        remark: "",
      }
    })
  };
  const handleFirstForm = (values) => {
    setSubTitle(values.subTitle)

    setCreateFormData({
      ...createFormData, ...{
        rb_work_category: values.workTypeSelected,
        rb_work_condition: values.subWorkTypeSelected,
        description: values.description,
        name: values.name,
        remark: "",
      }
    })
    if (newForm < 2)
      setForm(newForm + 1);
    else
      handleConfirmDialog()
  };
  const handleBackToDefaultForm = () => {
    if (newForm > 1)
      setForm(newForm - 1);
    else
      openDialog(false);
  };

  const [isSuccessDialogOpen, openConfirmDialog] = React.useState(false);
  const handleConfirmDialog = () => {
    openConfirmDialog(true)
    handleCloseDialog()
  };

  const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
  const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
  const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
  const [currentSelectedDeleteList, setSelectedDeleteList] = React.useState("");
  const [valueSerialList, setValueSerialList] = React.useState("");

  const [isAlertDialogOpen, openAlertDialogOpen] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [subTitle, setSubTitle] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [color, setColor] = React.useState("");
  const [colorHover, setColorHover] = React.useState("");
  const [size, setSize] = React.useState("");
  const [typeAlertDialog, setTypeAlertDialog] = React.useState("");
  const [errorText, seterrorText] = React.useState("");
  const onCloseAlertDialog = () => {
    setTitle("")
    setMessage("")
    setColor("")
    setTypeAlertDialog("")
    setColorHover("")
    setSize("")
    openAlertDialogOpen(false)
  }

  const onOpenAlertDialog = (title, message, color, type, colorHover, size) => {
    setTitle(title)
    setMessage(message)
    setColor(color)
    setColorHover(colorHover)
    setTypeAlertDialog(type)
    setColorHover(colorHover)
    setSize(size)
    openAlertDialogOpen(true)
  }

  const handleConfirmDeleteDialog = (val) => {
    openConfirmDeleteDialog(val)
  };
  const handleDeleteList = (event) => {
    setSelectedDeleteList("")
    if (event) setSelectedDeleteList(event.portfolio.serial)
    setValueSerialList(event.portfolio.serial)
    handleConfirmDeleteDialog(true)
  };
  const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
  const handleOpenFailedMessageDialog = (value) => {
    setFailedMessageDialog(true);
  };
  const handleCloseFailedMessageDialog = (value) => {
    setFailedMessageDialog(false);
  };
  const handleConfirmDeleteList = () => {
    workloadAndPerformanceService.DeleteList(valueSerialList).then(
      (response) => {
        let filteredData = workloadDetailList.filter(item => item.workloadFormSelectValue !== currentSelectedDeleteList)
        if (filteredData) setWorkloadDetailList(filteredData);
        handleConfirmDeleteDialog(false)
        openSuccessDeleteDialog(true)
        dispatch(getPortfolioDetailSummary(workloadFormSelectValue))
          .then(resp => {
            setSummaryItem(resp)
          })
        dispatch(getPortfolioDetailList(workloadFormSelectValue))
          .then(resp => {
            setWorkloadDetailList(resp.all)
            setFilteredList(resp.all)
          })
      },
    ).catch(() => {
      seterrorText('กรุณาลบรายการภาระงานและผลงาน')
      handleOpenFailedMessageDialog(true)
    })
  };

  const handleCreateForm = async (values, academic_unit) => {
    // let tempList = workloadDetailList
    // tempList.push(createFormData)
    // setWorkloadDetailList(tempList)
    workloadAndPerformanceService.addList({ ...createFormData, value: values, remark: values.remark, academic_unit: academic_unit?.value }, currentEditForm?.id).then(
      (response) => {
        dispatch(getPortfolioDetailSummary(workloadFormSelectValue))
          .then(resp => {
            setSummaryItem(resp)
          })
        dispatch(getPortfolioDetailList(workloadFormSelectValue))
          .then(resp => {
            setWorkloadDetailList(resp.all)
            setFilteredList(resp.all)
          })
        openSuccessAddDialog(true)
        handleCloseDialog(true)
      },
    ).catch(() => {
      if (currentEditForm?.id !== undefined && currentEditForm?.id !== null && currentEditForm?.id !== "") {
        seterrorText('กรุณาแก้ไขรายการภาระงานและผลงาน')
      } else {
        seterrorText('กรุณาเพิ่มรายการภาระงานและผลงาน')
      }
      handleOpenFailedMessageDialog()
    })
    handleCloseDialog()
    // ,values.start_at.toDateString()
    // ,values.start_at.toISOString()
    // ,values.start_at.toLocaleDateString()
    // ,values.start_at.toString()
    // ,values.start_at.toString()
    // ,values.start_at.toTimeString()
    // ,values.start_at.valueOf()
    // ,values.start_at.toUTCString());
    // onOpenAlertDialog("ดำเนินการสำเร็จ","เพิ่มรายการภาระงานและผลงานสำเร็จ", "#CC6058","success","#000","sm")
  }

  const [currentEditForm, setEditForm] = React.useState({ id: "", isManual: "" });
  const handleEditForm = (values) => {
    setEditForm({ id: values?.portfolio?.serial, isManual: values?.portfolio?.isManual })
    handleOpenDialog()
  }
  // useEffect start here
  useEffect(() => {
    // initial load dropdown
    dispatch(getPortfolioList())
      .then(resp => {

        setWorkloadForm(resp)
        if (resp !== undefined && resp.length > 0) {
          let datas = resp.find((rs) => rs?.is_default === true)
          setWorkloadFormValue(datas?.value)
        }
      })
    dispatch(getPortfolioWorkloadTypeList())
      .then(resp => {
        var typeData = []
        for (let index = 0; index <= resp.length - 1; index++) {
          // if (Object.keys(resp)[index] !== "all" && resp[Object.keys(resp)[index]].length > 0) {
          typeData.push({ text: resp[index].workCategory.descriptionTH, value: resp[index].workCategory.code })
          // }
        }
        setWorkloadTypeList(typeData)
      })
    handleChangeSummaryItem(workloadFormSelectValue)

  }, []);

  useEffect(() => {
    dispatch(getPortfolioDetailList(workloadFormSelectValue))
      .then(resp => {
        if (resp?.all !== undefined && resp?.all.length > 0) {
          setWorkloadDetailList(resp.all)
          setFilteredList(resp.all)
        }
      })
    dispatch(getPortfolioDetailSummary(workloadFormSelectValue))
      .then(resp => {
        setSummaryItem(resp)
      })
  }, [workloadFormSelectValue]);
  // ----------------------------------
  const useStyles = makeStyles({
    root: {
      fontSize: "16px",
    },
    plusSvg: {
      "& > path": {
        fill: "#fff",
        stroke: "#fff",
      }
    },
    paginationRoot: {
      color: `${cssVariables.color.primary}`,
      backgroundColor: "white!important",
      minWidth: "30px!important",
      padding: "5px!important",
    },
    paginationSelected: {
      color: "white!important",
      border: "1px solid rgba(93, 161, 150, 0.5)!important",
      backgroundColor: `${cssVariables.color.primary}!important`,
      minWidth: "30px!important",
      padding: "5px!important",
    },
    clickable: {
      cursor: "pointer",
      transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      '&:hover': {
        color: 'rgb(65, 112, 105) !important'
      }
    },
    fillDisable: {
      '& > path': {
        fill: '#A0A0A0'
      },
      '& g > path': {
        fill: '#A0A0A0'
      },
    },
    btn: {
      '& > svg': {
        marginLeft: "10px"
      },
    },
  });
  const classes = useStyles();
  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  };
  const navigate = useNavigate();
  const acceptConsent = (data) => {
    navigate(data, { replace: false });
  }
  return (
    <>
      <Helmet>
        <title>HOME | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => acceptConsent('/kpi/home')}>{t('label.home')}</span> / <span style={styles.end} >รายการภาระงานและผลงาน</span></Typography>
          </Grid>
          {/* start portfoliio 10*/}
          {/* <Grid container item> */}
          <Grid container >
            <Grid item md={12} >
              <Typography variant="h1" fontSize={36} lineHeight="39.6px" fontWeight="500">
                {t("portfolio.label.myWorkload")}
              </Typography>
              {workloadFormSelect?.length > 0 ?
                <Grid container item my={3}>
                  <Grid item md={6} pr={1}>
                    <Select
                      id="workload-select"
                      inputlabelprops={{ shrink: false }}
                      variant="outlined"
                      size="small"
                      className="white-bg"
                      value={workloadFormSelectValue}
                      onChange={handleChangeWorkloadForm}
                    >
                      {
                        workloadFormSelect?.length > 0 ?
                          workloadFormSelect.map(item => {
                            return (
                              <MenuItem value={item.value} key={item.value}>
                                {item.name}
                              </MenuItem>
                            )
                          })

                          : <MenuItem value="">
                            ---ไม่พบข้อมูล---
                          </MenuItem>
                      }
                    </Select>
                  </Grid>
                  <Grid
                    item
                    md={6}
                    display="flex"
                    alignItems="flex-end"
                    flexDirection="row-reverse"
                  >
                    <Box>
                      <Typography fontWeight="fontWeightLight" fontSize={12} variant="label">
                        {/* ข้อมูลวันที่ : {t("portfolio.label.dataDate")} */}
                        ข้อมูลวันที่ : {new Date().toLocaleString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
                          year: '2-digit',
                          month: 'short',
                          day: 'numeric',
                        })}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                : null}
            </Grid>
          </Grid>
          {workloadFormSelect?.length > 0 ?
            <Grid container spacing={4}>
              <Grid item lg={3} xs={12}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={6}
                        xs={12}
                        display="flex"
                        alignItems="center"
                        textAlign="left"
                      >
                        <Typography fontSize={14} lineHeight="21px" fontWeight="400">
                          ภาระงานและผลงานทั้งหมด
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        xs={12}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography fontSize={36} color="primary">{summaryItems.total}</Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={3} xs={12}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={6}
                        xs={12}
                        display="flex"
                        alignItems="center"
                        textAlign="left"
                      >
                        <Typography fontSize={14} lineHeight="21px" fontWeight="400">จำนวนภาระงาน</Typography>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        xs={12}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography fontSize={36} color="primary">{summaryItems.work}</Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={3} xs={12}>
                <Card>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={6}
                        xs={12}
                        display="flex"
                        alignItems="center"
                        textAlign="left"
                      >
                        <Typography fontSize={14} lineHeight="21px" fontWeight="400">จำนวนผลงาน</Typography>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        xs={12}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography fontSize={36} color="primary">{summaryItems.performance}</Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={3} xs={12}>
                <Card sx={{ background: '#E4E4E4', maxHeight: "94px" }}>
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        lg={6}
                        xs={12}
                        display="flex"
                        alignItems="center"
                        textAlign="left"
                      >
                        <Typography fontSize={14} lineHeight="21px" fontWeight="400">
                          สัดส่วนความคืบหน้าของการบันทึกข้อตกลง
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        xs={12}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography fontSize={36} fontWeight="400" color="#A0A0A0" variant="label">{summaryItems.progress}%</Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            : null}
          {workloadFormSelect?.length > 0 ?
            <Grid container item pt={1} alignItems="center" sx={{ paddingTop: "10px", paddingBottom: "0px" }}>
              <Box sx={{ flex: 1 }} />
              {/* <Link
                    component={RouterLink}
                    to="/app/workload-and-performance"
                > */}
              <Typography fontSize="12px" lineHeight="13.2px" fontWeight="300" variant="label" sx={{ display: "flex", alignItems: "center", color: '#A0A0A0' }} classes={{ root: classes.btn }}>
                ไปที่การบันทึกข้อตกลง <Arrow class={`${classes.fillDisable}`} />
              </Typography>
              {/* </Link> */}
            </Grid>
            : null}
          {/* end  portfoliio 10*/}
          {/* start portfoliio 20*/}
          {workloadFormSelect?.length > 0 ?
            <Grid container mt={5}>
              <Grid item lg={12} md={12}>
                <Typography variant="h1" fontSize={30} lineHeight="33px" fontWeight="500">
                  {t("portfolio.label.workloadReport")}
                  {
                    workloadFormSelect?.length > 0 ?
                      workloadFormSelect.map(item => {
                        return (
                          <span variant="h1" value={item.value} key={item.value} style={{ paddingLeft: "20px" }}>{item.name}</span>
                        )
                      })

                      :
                      <span variant="h1"></span>
                  }
                </Typography>
                <Typography fontSize={16} lineHeight="23.28px" fontWeight="400" sx={{ paddingTop: "10px" }}>
                  {t("portfolio.label.workloadReportDesc")}
                </Typography>
              </Grid>
            </Grid>
            : null}
          {workloadFormSelect?.length > 0 ?
            <Grid container sx={{ borderBottom: "1px solid #e4e4e4" }} mt={4}>
              <Grid item lg={11} md={11}>
                <Tabs
                  value={valueTab}
                  indicatorColor="primary"
                  textColor="primary"
                  onChange={handleChangeWorkloadType}
                  aria-label="Tabs"
                  TabIndicatorProps={{
                    style: {
                      height: "8px",
                      fontSize: "20px",
                    },
                  }}
                >
                  <Tab sx={{ fontWeight: "400" }} label={<span className={classes.root}>ทั้งหมด ({workloadDetailList?.length})</span>} value="all" />
                  {workloadTypeList.length > 0 ?
                    workloadTypeList.map(item => (
                      <Tab sx={{ fontWeight: "400" }}
                        label={
                          <span className={classes.root}>{item.text} ({workloadDetailList?.filter(x => x.workTypeCode === item.value).length})</span>
                        }
                        value={item.value}
                      />
                    )
                    ) : ""
                  }
                </Tabs>
              </Grid>
              <Grid
                item
                lg={1}
                md={1}
                display="flex"
                alignItems="flex-start"
                flexDirection="row-reverse"
              >
                <Button
                  size="small"
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleOpenDialog}
                  color="primary"
                  variant="contained"
                >
                  <PlusIcon className={classes.plusSvg} />
                  <Typography ml={1}>เพิ่ม</Typography>
                </Button>
              </Grid>
            </Grid>
            : null}
          {workloadFormSelect?.length > 0 ?
            currentTableData?.length > 0 ?
              currentTableData.length > 0 ?
                currentTableData.map(item => (
                  <Grid container spacing={4} mt={0}>
                    <Grid item lg={12} md={12}>
                      <Grid container spacing={5}>
                        <Grid item xs={12}>
                          <PortfolioCard item={item} add={handleOpenDialog} delete={handleDeleteList} edit={handleEditForm}></PortfolioCard>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )
                ) : (<Grid container spacing={4} mt={5}>
                  <Grid item lg={12} md={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      flexDirection="column"
                      p={1}
                    >
                      <Box>
                        <img src={fileBrowser} alt="browser" />
                      </Box>
                      <Box>
                        <Typography variant="sub_label">{t("portfolio.label.nodata")} หากต้องการเพิ่มข้อมูลให้</Typography>
                      </Box>
                      <Box>
                        <Typography
                          classes={{ root: classes.clickable }}
                          style={{ color: "#5DA196", fontWeight: "500", textDecoration: "underline" }}
                          onClick={handleOpenDialog}
                        >
                          {/* {t("portfolio.label.clickhere")} */}
                          คลิกที่นี่
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>)
              : (<Grid container spacing={4} mt={5}>
                <Grid item lg={12} md={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                    p={1}
                  >
                    <Box>
                      <img src={fileBrowser} alt="browser" />
                    </Box>
                    <Box>
                      <Typography variant="sub_label">{t("portfolio.label.nodata")} หากต้องการเพิ่มข้อมูลให้</Typography>
                    </Box>
                    <Box>
                      <Typography
                        classes={{ root: classes.clickable }}
                        style={{ color: "#5DA196", fontWeight: "500", textDecoration: "underline" }}
                        onClick={handleOpenDialog}
                      >
                        {/* {t("portfolio.label.clickhere")} */}
                        คลิกที่นี่
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>)
            : null
          }
          {workloadFormSelect?.length > 0 ?
            <Grid item md={12} pb={2} pt={2} sx={{ paddingTop: "60px" }}>
              <Divider />
            </Grid>
            : null}
          {workloadFormSelect?.length > 0 ?
            <Grid container mt={1} spacing={2}>
              <Grid item xs sm md display="flex" alignItems="center">
                <Box mr={1}>
                  <Typography variant="s14_fw400">แสดงรายการ</Typography>
                </Box>
                <Select
                  id="pagination"
                  variant="outlined"
                  defaultValue={25}
                  value={perPage}
                  onChange={handlePerPageChange}
                  displayEmpty
                  size="small"
                  className="white-bg"
                >
                  <MenuItem value={25}>
                    <Typography style={{ fontWeight: "300" }}>25</Typography>
                  </MenuItem>
                  <MenuItem value={50}>
                    <Typography style={{ fontWeight: "300" }}>50</Typography>
                  </MenuItem>
                  <MenuItem value={75}>
                    <Typography style={{ fontWeight: "300" }}>75</Typography>
                  </MenuItem>
                </Select>
              </Grid>
              <Grid item display="flex" alignItems="center" ml="auto">
                <Typography variant="s14_fw400">
                  หน้า {currentPage} จาก {totalPage}
                </Typography>
              </Grid>
              <Grid item ml="auto" display="flex" alignItems="center">
                <CustomPagination
                  setCurrentPage={handleSetCurrentPage}
                  selected={currentPage}
                  count={totalPage}
                ></CustomPagination>
              </Grid>
            </Grid>
            : null}
          {workloadFormSelect?.length < 1 ?
            <Grid container mt={10} spacing={2}>
              <Grid item xs sm md display="flex" flexDirection="column" alignItems="center">
                <Box>
                  <img src={emtyData} alt="emty-data" />
                </Box>
                <Box pt={2}>
                  <Typography variant="h1" fontSize={14} lineHeight="21px" fontWeight="300" color="#939393">
                    คุณยังไม่มี ข้อตกลงภาระงาน
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="h1" fontSize={14} lineHeight="21px" fontWeight="300" color="#939393">
                    รายการภาระงานและผลงานจะแสดงผลขึ้นตามข้อตกลงภาระงานของคุณ
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            : null}
          <Dialog onBackdropClick={() => { return false }} open={isAddDialogOpen} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="lg" PaperProps={{ sx: { padding: '10px' } }}>
            <DialogTitle id="form-add-dialog-title" fontSize={24}>
              {titleAdd()}
              <Box sx={{ position: "absolute", right: 0, margin: "30px 20px 0  0", top: 0 }} className="clickable" onClick={handleCloseDialog}><img src={CloseIcon} alt="browser" /></Box>
            </DialogTitle>
            <DialogContent px={0} pb={0}>
              <Divider />
              {
                newForm === 1 ?
                  <DefaultForm close={handleCloseDialog} submit={handleFirstForm} item={currentEditForm} data={createFormData}></DefaultForm>
                  : <CustomForm close={handleBackToDefaultForm} subTitle={subTitle} serial={createFormData.rb_work_condition} submit={handleCreateForm} item={currentEditForm}></CustomForm>
              }
            </DialogContent>
          </Dialog>
          <SimpleDialog open={isSuccessDialogOpen} setValue={openConfirmDialog} text="เพิ่มรายการภาระงานและผลงาน" />
          <ConfirmDialog open={isConfirmDeleteDialogOpen} trash={true} doConfirm={handleConfirmDeleteList} setValue={handleConfirmDeleteDialog} title="ยืนยันการลบรายการภาระงานและผลงาน" text="ต้องการยืนยันการลบรายการภาระงานและผลงานหรือไม่ ?" />
          <AlertDialog
            open={isAlertDialogOpen}
            title={title}
            message={message}
            type={typeAlertDialog}
            color={color}
            close={onCloseAlertDialog}
            acceptConfirm=""
            colorHover={colorHover}
            size={size}
          />
          <SimpleDialog open={isSuccessDeleteDialogOpen} setValue={openSuccessDeleteDialog} text="การลบรายการภาระงานและผลงาน" />
          <SimpleDialog open={isSuccessAddDialogOpen} setValue={openSuccessAddDialog} text="เพิ่มรายการภาระงานและผลงาน" />
          <MessageDialog open={openFailedMessageDialog} setValue={handleCloseFailedMessageDialog} type="fail" title="ดำเนินการไม่สำเร็จ" text={errorText + " \nใหม่อีกครั้ง"} />
        </Container>
      </Box>
    </>
  );
};
export default Portfolio;
